export class OrderDocumentDownloadResModel {
  Extension: string;
  FileName: string;
  byteFile: string;
}
